import EconomyModeApi from './economy-mode-api';

export default EconomyModeApi;
